import { useModules } from "src/api/modulesApi";
import { ConnectModuleConfig, ModuleKind } from "src/clients/flow-api";

/**
 * Reads `use_sdk_features` from the connect module's deployed config. Uses the
 * same query key as `WorkspaceRoutesContext`, so under workspace routes it
 * resolves from the React Query cache without an extra request — while staying
 * usable in components that are not guaranteed to sit below the workspace
 * outlet context (unlike `useIsModuleEnabled`).
 */
export const useConnectSdkFeaturesEnabled = (
  workspaceId: string | undefined,
): { isEnabled: boolean } => {
  const { data: modules } = useModules({
    workspaceId,
    enabled: Boolean(workspaceId),
  });

  const spec = modules?.find(
    (module) =>
      module.kind === ModuleKind.CONNECT && Boolean(module.spec?.is_active),
  )?.spec;

  return {
    isEnabled:
      (spec?.config as ConnectModuleConfig | undefined)?.use_sdk_features ===
      true,
  };
};
